/**
 * Do not edit directly, this file was auto-generated.
 */


/**
 * Design Tokens - Auto-generated from tokens/*.tokens.json
 * DO NOT EDIT DIRECTLY - Run 'npm run tokens:build' to regenerate
 */

export const tokens = {
  "COLOR_NAVIGATION_TIMELINE": "#1a65d6",
  "COLOR_NAVIGATION_LEGACYBACKGROUND": "#282c34",
  "COLOR_NAVIGATION_LEGACYACCENT": "#61dafb",
  "COLOR_UPLOAD_SUCCESS": "#22c55e",
  "COLOR_UPLOAD_METASEPARATOR": "#444444",
  "COLOR_UPLOAD_ROLEHOVER": "#e34f80",
  "COLOR_WORKFLOW_OUTPUT_GENERATING": "#ffc107",
  "COLOR_WORKFLOW_OUTPUT_AUDIOPLAYHOVER": "#3488d4",
  "COLOR_WORKFLOW_OUTPUT_TEXTHOVER": "#cccccc",
  "COLOR_PRIMITIVE_YELLOW_300": "#fcd34d",
  "COLOR_PRIMITIVE_YELLOW_400": "#fbbf24",
  "COLOR_PRIMITIVE_GREEN_500": "#5cc68d",
  "COLOR_PRIMITIVE_AMBER_500": "#f3b346",
  "COLOR_PRIMITIVE_AMBER_600": "#f59e0b",
  "COLOR_PRIMITIVE_PINK_500": "#e30f63",
  "COLOR_PRIMITIVE_BLUSH_500": "#dc5d90",
  "COLOR_PRIMITIVE_MAGENTA_500": "#b86ba2",
  "COLOR_PRIMITIVE_VIOLET_400": "#b96bc5",
  "COLOR_PRIMITIVE_VIOLET_500": "#a654b2",
  "COLOR_PRIMITIVE_AFRICANVIOLET_500": "#9579b5",
  "COLOR_PRIMITIVE_INDIGO_500": "#6e6cbe",
  "COLOR_PRIMITIVE_PLUM_500": "#cb3891",
  "COLOR_PRIMITIVE_BLUE_400": "#7fb8e8",
  "COLOR_PRIMITIVE_BLUE_500": "#2978c4",
  "COLOR_PRIMITIVE_NEUTRAL_0": "#ffffff",
  "COLOR_PRIMITIVE_NEUTRAL_50": "#f7fafc",
  "COLOR_PRIMITIVE_NEUTRAL_100": "#f1f3f8",
  "COLOR_PRIMITIVE_NEUTRAL_150": "#dddddd",
  "COLOR_PRIMITIVE_NEUTRAL_175": "#aaaaaa",
  "COLOR_PRIMITIVE_NEUTRAL_200": "#999999",
  "COLOR_PRIMITIVE_NEUTRAL_300": "#888888",
  "COLOR_PRIMITIVE_NEUTRAL_350": "#7f7f7f",
  "COLOR_PRIMITIVE_NEUTRAL_375": "#777777",
  "COLOR_PRIMITIVE_NEUTRAL_400": "#666666",
  "COLOR_PRIMITIVE_NEUTRAL_500": "#555555",
  "COLOR_PRIMITIVE_NEUTRAL_550": "#4a4a4a",
  "COLOR_PRIMITIVE_NEUTRAL_600": "#3a3a3a",
  "COLOR_PRIMITIVE_NEUTRAL_700": "#2d2d2d",
  "COLOR_PRIMITIVE_NEUTRAL_725": "#333333",
  "COLOR_PRIMITIVE_NEUTRAL_750": "#2a2a2a",
  "COLOR_PRIMITIVE_NEUTRAL_800": "#252525",
  "COLOR_PRIMITIVE_NEUTRAL_900": "#1a1a1a",
  "COLOR_PRIMITIVE_NEUTRAL_950": "#141414",
  "COLOR_PRIMITIVE_NEUTRAL_1000": "#000000",
  "COLOR_PRIMITIVE_RED_500": "#ef4444",
  "COLOR_SEMANTIC_ACCENT": "#e30f63",
  "COLOR_SEMANTIC_SECONDARY": "#2978c4",
  "COLOR_SEMANTIC_VIOLET": "#a654b2",
  "COLOR_SEMANTIC_INDIGO": "#6e6cbe",
  "COLOR_SEMANTIC_ASSETTYPE_VIDEO": "#e30f63",
  "COLOR_SEMANTIC_ASSETTYPE_IMAGE": "#a654b2",
  "COLOR_SEMANTIC_ASSETTYPE_AUDIO": "#2978c4",
  "COLOR_SEMANTIC_GRADIENT_STEP1": "#e30f63",
  "COLOR_SEMANTIC_GRADIENT_STEP2": "#dc5d90",
  "COLOR_SEMANTIC_GRADIENT_STEP3": "#b86ba2",
  "COLOR_SEMANTIC_GRADIENT_STEP4": "#9579b5",
  "COLOR_SEMANTIC_GRADIENT_STEP5": "#2978c4",
  "COLOR_SEMANTIC_DESTRUCTIVE": "#ef4444",
  "COLOR_SEMANTIC_SURFACE_THUMBNAILPANEL": "#1a1d22",
  "COLOR_SEMANTIC_SURFACE_THUMBNAILAVATAR": "#2a2d32",
  "COLOR_SEMANTIC_SURFACE_DEFAULT": "#ffffff",
  "COLOR_SEMANTIC_SURFACE_DARK": "#1a1a1a",
  "COLOR_SEMANTIC_SURFACE_ELEVATED": "#252525",
  "COLOR_SEMANTIC_SURFACE_CARD": "#2d2d2d",
  "COLOR_SEMANTIC_SURFACE_PANEL": "#f1f3f8",
  "COLOR_SEMANTIC_BORDER_DEFAULT": "#3a3a3a",
  "COLOR_SEMANTIC_BORDER_LIGHT": "#d8dce3",
  "COLOR_SEMANTIC_TEXT_PRIMARY": "#1a1a1a",
  "COLOR_SEMANTIC_TEXT_PRIMARYDARK": "#ffffff",
  "COLOR_SEMANTIC_TEXT_SECONDARY": "#666666",
  "COLOR_SEMANTIC_TEXT_MUTED": "#888888",
  "COLOR_SEMANTIC_TEXT_PLACEHOLDER": "#999999",
  "COLOR_SEMANTIC_OVERLAY": "#000000",
  "COLOR_INTERACTIVE_PINK_BG": "#e30f63",
  "COLOR_INTERACTIVE_PINK_BGHOVER": "#ff6b9d",
  "COLOR_INTERACTIVE_PINK_BGACTIVE": "#e6456f",
  "COLOR_INTERACTIVE_PINK_BORDER": "#e30f63",
  "COLOR_INTERACTIVE_VIOLET_BG": "#a654b2",
  "COLOR_INTERACTIVE_VIOLET_BGHOVER": "#b96bc5",
  "COLOR_INTERACTIVE_VIOLET_BGACTIVE": "#8f4799",
  "COLOR_INTERACTIVE_VIOLET_BORDER": "#a654b2",
  "COLOR_INTERACTIVE_VIOLET_BGMUTED": "#a654b2",
  "COLOR_INTERACTIVE_VIOLET_BGMUTEDHOVER": "#a654b2",
  "COLOR_INTERACTIVE_VIOLET_BORDERMUTED": "#a654b2",
  "COLOR_INTERACTIVE_INDIGO_BG": "#6e6cbe",
  "COLOR_INTERACTIVE_INDIGO_BGHOVER": "#8583d0",
  "COLOR_INTERACTIVE_INDIGO_BGACTIVE": "#5a58a6",
  "COLOR_INTERACTIVE_INDIGO_BORDER": "#6e6cbe",
  "COLOR_INTERACTIVE_INDIGO_BGMUTED": "#6e6cbe",
  "COLOR_INTERACTIVE_INDIGO_BGMUTEDHOVER": "#6e6cbe",
  "COLOR_INTERACTIVE_INDIGO_BORDERMUTED": "#6e6cbe",
  "COLOR_INTERACTIVE_COBALT_BG": "#2978c4",
  "COLOR_INTERACTIVE_COBALT_BGHOVER": "#6aa8e3",
  "COLOR_INTERACTIVE_COBALT_BGACTIVE": "#3d7fbf",
  "COLOR_INTERACTIVE_BLUE_BG": "rgba(var(--color-primitive-blue-500-rgb),0.15)",
  "COLOR_INTERACTIVE_BLUE_BGHOVER": "rgba(var(--color-primitive-blue-500-rgb),0.25)",
  "COLOR_INTERACTIVE_BLUE_BGACTIVE": "rgba(var(--color-primitive-blue-500-rgb),0.35)",
  "COLOR_INTERACTIVE_BLUE_BORDER": "rgba(var(--color-primitive-blue-500-rgb),0.4)",
  "COLOR_INTERACTIVE_BLUE_BORDERHOVER": "rgba(var(--color-primitive-blue-500-rgb),0.6)",
  "COLOR_INTERACTIVE_BLUE_TEXT": "#7fb8e8",
  "COLOR_INTERACTIVE_BLUE_TEXTHOVER": "#a8d0f2",
  "COLOR_INTERACTIVE_GREY_BG": "#000000",
  "COLOR_INTERACTIVE_GREY_BGHOVER": "#000000",
  "COLOR_INTERACTIVE_GREY_BGACTIVE": "#000000",
  "COLOR_INTERACTIVE_GREY_BORDER": "#000000",
  "COLOR_INTERACTIVE_GREY_BORDERHOVER": "#000000",
  "COLOR_INTERACTIVE_GREY_BGDARK": "#ffffff",
  "COLOR_INTERACTIVE_GREY_BGDARKHOVER": "#ffffff",
  "COLOR_INTERACTIVE_GREY_BGDARKACTIVE": "#ffffff",
  "COLOR_INTERACTIVE_GREY_BORDERDARK": "#ffffff",
  "COLOR_INTERACTIVE_GREY_BORDERDARKHOVER": "#ffffff",
  "COLOR_INTERACTIVE_GREY_TEXT": "#555555",
  "COLOR_INTERACTIVE_GREY_TEXTHOVER": "#333333",
  "COLOR_INTERACTIVE_GREY_TEXTDARK": "#999999",
  "COLOR_INTERACTIVE_GREY_TEXTDARKHOVER": "#ffffff",
  "COLOR_INTERACTIVE_RED_BG": "#ef4444",
  "COLOR_INTERACTIVE_RED_BGHOVER": "#ef4444",
  "COLOR_INTERACTIVE_RED_BGACTIVE": "#ef4444",
  "COLOR_INTERACTIVE_RED_BORDER": "#ef4444",
  "COLOR_INTERACTIVE_RED_BORDERHOVER": "#ef4444",
  "COLOR_INTERACTIVE_RED_TEXT": "#ef4444",
  "COLOR_INTERACTIVE_RED_TEXTHOVER": "#f87171",
  "COLOR_INTERACTIVE_UTILITY_TEXT": "#8b8e96",
  "COLOR_INTERACTIVE_UTILITY_TEXTHOVER": "#f0f0f0",
  "COLOR_INTERACTIVE_UTILITY_BGHOVER": "#ffffff",
  "COLOR_INTERACTIVE_UTILITYDESTRUCTIVE_BGHOVER": "#c43d56",
  "COLOR_INTERACTIVE_UTILITYDESTRUCTIVE_TEXTHOVER": "#c43d56",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_VIDEO_OUTER": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_VIDEO_OUTERSELECTED": "#ff6b9d",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_VIDEO_INNERBASE": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_VIDEO_GLOWCOLORBASE": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_VIDEO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_AUDIO_OUTER": "#2978c4",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_AUDIO_OUTERSELECTED": "#6aa8e3",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_AUDIO_INNERBASE": "#2978c4",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_AUDIO_GLOWCOLORBASE": "#2978c4",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_AUDIO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_IMAGE_OUTER": "#a654b2",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_IMAGE_OUTERSELECTED": "#b96bc5",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_IMAGE_INNERBASE": "#a654b2",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_IMAGE_GLOWCOLORBASE": "#a654b2",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_IMAGE_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_OVERLAY_OUTER": "#f3b346",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_OVERLAY_OUTERSELECTED": "#f5c56b",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_OVERLAY_INNERBASE": "#f3b346",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_OVERLAY_GLOWCOLORBASE": "#f3b346",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_OVERLAY_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_PLACEHOLDER_OUTER": "#7f7f7f",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_PLACEHOLDER_OUTERSELECTED": "#bfbfbf",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_PLACEHOLDER_INNERBASE": "#b4bec8",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_PLACEHOLDER_GLOWCOLORBASE": "#7f7f7f",
  "COLOR_TIMELINE_SKINS_DEFAULT_CLIPCOLORS_PLACEHOLDER_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_TRACKBACKGROUNDACTIVE_0": "#222222",
  "COLOR_TIMELINE_SKINS_DEFAULT_TRACKBACKGROUNDACTIVE_1": "#1c1c1c",
  "COLOR_TIMELINE_SKINS_DEFAULT_TRACKBACKGROUNDINACTIVE_0": "#181818",
  "COLOR_TIMELINE_SKINS_DEFAULT_TRACKBACKGROUNDINACTIVE_1": "#141414",
  "COLOR_TIMELINE_SKINS_DEFAULT_GRIDLINECOLOR": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_BORDERCOLOR": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_RULERBACKGROUNDTOP": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_RULERBACKGROUNDBOTTOM": "#2a2a2a",
  "COLOR_TIMELINE_SKINS_DEFAULT_RULERTEXTCOLOR": "#b8b8b8",
  "COLOR_TIMELINE_SKINS_DEFAULT_RULERTICKCOLOR": "#b8b8b8",
  "COLOR_TIMELINE_SKINS_DEFAULT_PLAYHEADCOLOR": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_PLAYHEADCOLORDRAGGING": "#ff8dc7",
  "COLOR_TIMELINE_SKINS_DEFAULT_PANELBACKGROUND": "#2a2a2a",
  "COLOR_TIMELINE_SKINS_DEFAULT_HEADERBACKGROUND": "#1e1e1e",
  "COLOR_TIMELINE_SKINS_DEFAULT_TEXTCOLOR": "#e0e0e0",
  "COLOR_TIMELINE_SKINS_DEFAULT_TEXTCOLORMUTED": "#808080",
  "COLOR_TIMELINE_SKINS_DEFAULT_BUTTONBACKGROUNDBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_BUTTONBACKGROUNDHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_BUTTONTEXT": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_BUTTONBORDERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_SELECTIONCOLORBASE": "#ff69b4",
  "COLOR_TIMELINE_SKINS_DEFAULT_DROPPREVIEWCOLORBASE": "#64c8ff",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTBACKGROUND": "#333333",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTBACKGROUNDHOVER": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTBACKGROUNDFOCUS": "#2a2a2a",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTBORDER": "#444444",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTBORDERFOCUS": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_INPUTTEXT": "#e0e0e0",
  "COLOR_TIMELINE_SKINS_DEFAULT_CARDBACKGROUND": "#333333",
  "COLOR_TIMELINE_SKINS_DEFAULT_CARDBACKGROUNDHOVER": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_CARDBORDER": "#444444",
  "COLOR_TIMELINE_SKINS_DEFAULT_CARDSHADOWBASE": "#000000",
  "COLOR_TIMELINE_SKINS_DEFAULT_SCROLLBARTRACKBASE": "#000000",
  "COLOR_TIMELINE_SKINS_DEFAULT_SCROLLBARTHUMBBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_SCROLLBARTHUMBHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_DEFAULT_ACCENTPRIMARY": "#e30f63",
  "COLOR_TIMELINE_SKINS_DEFAULT_ACCENTSECONDARY": "#4a9eff",
  "COLOR_TIMELINE_SKINS_DEFAULT_DIVIDERCOLOR": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_SIDEBARBACKGROUND": "#252525",
  "COLOR_TIMELINE_SKINS_DEFAULT_SIDEBARBORDER": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_DEFAULT_SUCCESSCOLOR": "#4caf50",
  "COLOR_TIMELINE_SKINS_DEFAULT_WARNINGCOLOR": "#ffc107",
  "COLOR_TIMELINE_SKINS_DEFAULT_DANGERCOLOR": "#ff4444",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_VIDEO_OUTER": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_VIDEO_OUTERSELECTED": "#ff6b9d",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_VIDEO_INNERBASE": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_VIDEO_GLOWCOLORBASE": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_VIDEO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_AUDIO_OUTER": "#2978c4",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_AUDIO_OUTERSELECTED": "#6aa8e3",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_AUDIO_INNERBASE": "#2978c4",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_AUDIO_GLOWCOLORBASE": "#2978c4",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_AUDIO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_IMAGE_OUTER": "#a654b2",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_IMAGE_OUTERSELECTED": "#b96bc5",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_IMAGE_INNERBASE": "#a654b2",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_IMAGE_GLOWCOLORBASE": "#a654b2",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_IMAGE_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_OVERLAY_OUTER": "#607d8b",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_OVERLAY_OUTERSELECTED": "#90a4ae",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_OVERLAY_INNERBASE": "#607d8b",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_OVERLAY_GLOWCOLORBASE": "#607d8b",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_OVERLAY_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_PLACEHOLDER_OUTER": "#78909c",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_PLACEHOLDER_OUTERSELECTED": "#a7c0cd",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_PLACEHOLDER_INNERBASE": "#78909c",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_PLACEHOLDER_GLOWCOLORBASE": "#78909c",
  "COLOR_TIMELINE_SKINS_LIGHT_CLIPCOLORS_PLACEHOLDER_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_TRACKBACKGROUNDACTIVE_0": "#f8f9fa",
  "COLOR_TIMELINE_SKINS_LIGHT_TRACKBACKGROUNDACTIVE_1": "#f1f3f5",
  "COLOR_TIMELINE_SKINS_LIGHT_TRACKBACKGROUNDINACTIVE_0": "#f1f3f5",
  "COLOR_TIMELINE_SKINS_LIGHT_TRACKBACKGROUNDINACTIVE_1": "#e9ecef",
  "COLOR_TIMELINE_SKINS_LIGHT_GRIDLINECOLOR": "#dee2e6",
  "COLOR_TIMELINE_SKINS_LIGHT_BORDERCOLOR": "#ced4da",
  "COLOR_TIMELINE_SKINS_LIGHT_RULERBACKGROUNDTOP": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_RULERBACKGROUNDBOTTOM": "#f8f9fa",
  "COLOR_TIMELINE_SKINS_LIGHT_RULERTEXTCOLOR": "#1f2937",
  "COLOR_TIMELINE_SKINS_LIGHT_RULERTICKCOLOR": "#4b5563",
  "COLOR_TIMELINE_SKINS_LIGHT_PLAYHEADCOLOR": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_PLAYHEADCOLORDRAGGING": "#ff8dc7",
  "COLOR_TIMELINE_SKINS_LIGHT_PANELBACKGROUND": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_HEADERBACKGROUND": "#f1f3f5",
  "COLOR_TIMELINE_SKINS_LIGHT_TEXTCOLOR": "#1f2937",
  "COLOR_TIMELINE_SKINS_LIGHT_TEXTCOLORMUTED": "#6b7280",
  "COLOR_TIMELINE_SKINS_LIGHT_BUTTONBACKGROUNDBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_BUTTONBACKGROUNDHOVERBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_BUTTONTEXT": "#374151",
  "COLOR_TIMELINE_SKINS_LIGHT_BUTTONBORDER": "#ced4da",
  "COLOR_TIMELINE_SKINS_LIGHT_SELECTIONCOLORBASE": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_DROPPREVIEWCOLORBASE": "#2978c4",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTBACKGROUND": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTBACKGROUNDHOVER": "#f8f9fa",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTBACKGROUNDFOCUS": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTBORDER": "#ced4da",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTBORDERFOCUS": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_INPUTTEXT": "#1f2937",
  "COLOR_TIMELINE_SKINS_LIGHT_CARDBACKGROUND": "#ffffff",
  "COLOR_TIMELINE_SKINS_LIGHT_CARDBACKGROUNDHOVER": "#f8f9fa",
  "COLOR_TIMELINE_SKINS_LIGHT_CARDBORDER": "#e9ecef",
  "COLOR_TIMELINE_SKINS_LIGHT_CARDSHADOWBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_SCROLLBARTRACKBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_SCROLLBARTHUMBBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_SCROLLBARTHUMBHOVERBASE": "#000000",
  "COLOR_TIMELINE_SKINS_LIGHT_ACCENTPRIMARY": "#e30f63",
  "COLOR_TIMELINE_SKINS_LIGHT_ACCENTSECONDARY": "#2978c4",
  "COLOR_TIMELINE_SKINS_LIGHT_DIVIDERCOLOR": "#dee2e6",
  "COLOR_TIMELINE_SKINS_LIGHT_SIDEBARBACKGROUND": "#f1f3f5",
  "COLOR_TIMELINE_SKINS_LIGHT_SIDEBARBORDER": "#dee2e6",
  "COLOR_TIMELINE_SKINS_LIGHT_SUCCESSCOLOR": "#16a34a",
  "COLOR_TIMELINE_SKINS_LIGHT_WARNINGCOLOR": "#d97706",
  "COLOR_TIMELINE_SKINS_LIGHT_DANGERCOLOR": "#dc2626",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_VIDEO_OUTER": "#cd7f32",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_VIDEO_OUTERSELECTED": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_VIDEO_INNERBASE": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_VIDEO_GLOWCOLORBASE": "#cd7f32",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_VIDEO_TEXTCOLOR": "#ffeb3b",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_AUDIO_OUTER": "#708090",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_AUDIO_OUTERSELECTED": "#a0a8b0",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_AUDIO_INNERBASE": "#a0a8b0",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_AUDIO_GLOWCOLORBASE": "#708090",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_AUDIO_TEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_IMAGE_OUTER": "#b8860b",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_IMAGE_OUTERSELECTED": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_IMAGE_INNERBASE": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_IMAGE_GLOWCOLORBASE": "#b8860b",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_IMAGE_TEXTCOLOR": "#ffeb3b",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_OVERLAY_OUTER": "#4682b4",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_OVERLAY_OUTERSELECTED": "#5a9fd4",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_OVERLAY_INNERBASE": "#5a9fd4",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_OVERLAY_GLOWCOLORBASE": "#4682b4",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_OVERLAY_TEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_PLACEHOLDER_OUTER": "#556b2f",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_PLACEHOLDER_OUTERSELECTED": "#6b8e23",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_PLACEHOLDER_INNERBASE": "#6b8e23",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_PLACEHOLDER_GLOWCOLORBASE": "#556b2f",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CLIPCOLORS_PLACEHOLDER_TEXTCOLOR": "#ffeb3b",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TRACKBACKGROUNDACTIVE_0": "#1a1a2e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TRACKBACKGROUNDACTIVE_1": "#16213e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TRACKBACKGROUNDINACTIVE_0": "#0f0f1e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TRACKBACKGROUNDINACTIVE_1": "#0a0a14",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_GRIDLINECOLOR": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_BORDERCOLOR": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_RULERBACKGROUNDTOP": "#1a1a2e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_RULERBACKGROUNDBOTTOM": "#0f0f1e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_RULERTEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_RULERTICKCOLOR": "#708090",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_PLAYHEADCOLOR": "#ff6b35",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_PLAYHEADCOLORDRAGGING": "#ff8c42",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_PANELBACKGROUND": "#0f0f1e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_HEADERBACKGROUND": "#0a0a14",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_TEXTCOLORMUTED": "#708090",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_BUTTONBACKGROUNDBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_BUTTONBACKGROUNDHOVERBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_BUTTONTEXT": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_BUTTONBORDERBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SELECTIONCOLORBASE": "#ff6b35",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_DROPPREVIEWCOLORBASE": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTBACKGROUND": "#1a1a2e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTBACKGROUNDHOVER": "#16213e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTBACKGROUNDFOCUS": "#1a1a2e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTBORDER": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTBORDERFOCUS": "#ff6b35",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_INPUTTEXT": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CARDBACKGROUND": "#16213e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CARDBACKGROUNDHOVER": "#1a1a2e",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CARDBORDER": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_CARDSHADOWBASE": "#000000",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SCROLLBARTRACKBASE": "#000000",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SCROLLBARTHUMBBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SCROLLBARTHUMBHOVERBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_ACCENTPRIMARY": "#ff6b35",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_ACCENTSECONDARY": "#00ffff",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_DIVIDERCOLOR": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SIDEBARBACKGROUND": "#0a0a14",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SIDEBARBORDER": "#3d5a80",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_SUCCESSCOLOR": "#32cd32",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_WARNINGCOLOR": "#daa520",
  "COLOR_TIMELINE_SKINS_BITMAPBROTHERS_DANGERCOLOR": "#ff4500",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_VIDEO_OUTERBASE": "#fe4f7e",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_VIDEO_OUTERSELECTEDBASE": "#ff7a9e",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_VIDEO_INNERBASE": "#ffc8d2",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_VIDEO_GLOWCOLORBASE": "#fe4f7e",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_VIDEO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_AUDIO_OUTERBASE": "#7187c6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_AUDIO_OUTERSELECTEDBASE": "#8fa0d6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_AUDIO_INNERBASE": "#b4c8e6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_AUDIO_GLOWCOLORBASE": "#7187c6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_AUDIO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_IMAGE_OUTERBASE": "#9679b5",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_IMAGE_OUTERSELECTEDBASE": "#ae94cb",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_IMAGE_INNERBASE": "#c8b4dc",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_IMAGE_GLOWCOLORBASE": "#9679b5",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_IMAGE_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_OVERLAY_OUTERBASE": "#808080",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_OVERLAY_OUTERSELECTEDBASE": "#999999",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_OVERLAY_INNERBASE": "#b4b4b4",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_OVERLAY_GLOWCOLORBASE": "#808080",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_OVERLAY_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_PLACEHOLDER_OUTERBASE": "#95a5a6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_PLACEHOLDER_OUTERSELECTEDBASE": "#b0bec5",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_PLACEHOLDER_INNERBASE": "#b4bec8",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_PLACEHOLDER_GLOWCOLORBASE": "#95a5a6",
  "COLOR_TIMELINE_SKINS_GLASS_CLIPCOLORS_PLACEHOLDER_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_TRACKBACKGROUNDACTIVE_0BASE": "#2d2d2d",
  "COLOR_TIMELINE_SKINS_GLASS_TRACKBACKGROUNDACTIVE_1BASE": "#252525",
  "COLOR_TIMELINE_SKINS_GLASS_TRACKBACKGROUNDINACTIVE_0BASE": "#1f1f1f",
  "COLOR_TIMELINE_SKINS_GLASS_TRACKBACKGROUNDINACTIVE_1BASE": "#1a1a1a",
  "COLOR_TIMELINE_SKINS_GLASS_GRIDLINECOLORBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_RULERBACKGROUNDTOPBASE": "#3a3a3a",
  "COLOR_TIMELINE_SKINS_GLASS_RULERBACKGROUNDBOTTOMBASE": "#2a2a2a",
  "COLOR_TIMELINE_SKINS_GLASS_RULERTEXTCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_RULERTICKCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_PLAYHEADCOLORBASE": "#ff69b4",
  "COLOR_TIMELINE_SKINS_GLASS_PLAYHEADCOLORDRAGGINGBASE": "#ff8dc7",
  "COLOR_TIMELINE_SKINS_GLASS_PANELBACKGROUNDBASE": "#1e1e1e",
  "COLOR_TIMELINE_SKINS_GLASS_HEADERBACKGROUNDBASE": "#141414",
  "COLOR_TIMELINE_SKINS_GLASS_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_TEXTCOLORMUTEDBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_BUTTONBACKGROUNDBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_BUTTONBACKGROUNDHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_BUTTONTEXT": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_BUTTONBORDERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_SELECTIONCOLORBASE": "#ff69b4",
  "COLOR_TIMELINE_SKINS_GLASS_DROPPREVIEWCOLORBASE": "#64c8ff",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTBACKGROUNDBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTBACKGROUNDHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTBACKGROUNDFOCUSBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTBORDERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTBORDERFOCUSBASE": "#ff69b4",
  "COLOR_TIMELINE_SKINS_GLASS_INPUTTEXT": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CARDBACKGROUNDBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CARDBACKGROUNDHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CARDBORDERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_CARDSHADOWBASE": "#000000",
  "COLOR_TIMELINE_SKINS_GLASS_SCROLLBARTRACKBASE": "#000000",
  "COLOR_TIMELINE_SKINS_GLASS_SCROLLBARTHUMBBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_SCROLLBARTHUMBHOVERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_ACCENTPRIMARYBASE": "#ff69b4",
  "COLOR_TIMELINE_SKINS_GLASS_ACCENTSECONDARYBASE": "#64c8ff",
  "COLOR_TIMELINE_SKINS_GLASS_DIVIDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_SIDEBARBACKGROUNDBASE": "#141414",
  "COLOR_TIMELINE_SKINS_GLASS_SIDEBARBORDERBASE": "#ffffff",
  "COLOR_TIMELINE_SKINS_GLASS_SUCCESSCOLORBASE": "#4caf50",
  "COLOR_TIMELINE_SKINS_GLASS_WARNINGCOLORBASE": "#ffc107",
  "COLOR_TIMELINE_SKINS_GLASS_DANGERCOLORBASE": "#f44336",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_VIDEO_OUTER": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_VIDEO_OUTERSELECTED": "#ff66ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_VIDEO_INNERBASE": "#ff66ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_VIDEO_GLOWCOLORBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_VIDEO_TEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_AUDIO_OUTER": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_AUDIO_OUTERSELECTED": "#66ff66",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_AUDIO_INNERBASE": "#66ff66",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_AUDIO_GLOWCOLORBASE": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_AUDIO_TEXTCOLOR": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_IMAGE_OUTER": "#ffff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_IMAGE_OUTERSELECTED": "#ffff66",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_IMAGE_INNERBASE": "#ffff66",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_IMAGE_GLOWCOLORBASE": "#ffff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_IMAGE_TEXTCOLOR": "#0000ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_OVERLAY_OUTER": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_OVERLAY_OUTERSELECTED": "#66ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_OVERLAY_INNERBASE": "#66ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_OVERLAY_GLOWCOLORBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_OVERLAY_TEXTCOLOR": "#ff0000",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_PLACEHOLDER_OUTER": "#ff6600",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_PLACEHOLDER_OUTERSELECTED": "#ff9933",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_PLACEHOLDER_INNERBASE": "#ff9933",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_PLACEHOLDER_GLOWCOLORBASE": "#ff6600",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CLIPCOLORS_PLACEHOLDER_TEXTCOLOR": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TRACKBACKGROUNDACTIVE_0": "#1a0028",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TRACKBACKGROUNDACTIVE_1": "#140020",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TRACKBACKGROUNDINACTIVE_0": "#0f0018",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TRACKBACKGROUNDINACTIVE_1": "#0a0010",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_GRIDLINECOLORBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_BORDERCOLOR": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_RULERBACKGROUNDTOP": "#1a0028",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_RULERBACKGROUNDBOTTOM": "#0f0018",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_RULERTEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_RULERTICKCOLOR": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_PLAYHEADCOLOR": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_PLAYHEADCOLORDRAGGING": "#66ff66",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_PANELBACKGROUND": "#0a0010",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_HEADERBACKGROUND": "#050008",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TEXTCOLOR": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_TEXTCOLORMUTED": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_BUTTONBACKGROUNDBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_BUTTONBACKGROUNDHOVERBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_BUTTONTEXT": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_BUTTONBORDERBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SELECTIONCOLORBASE": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_DROPPREVIEWCOLORBASE": "#ffff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTBACKGROUND": "#140020",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTBACKGROUNDHOVER": "#1a0028",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTBACKGROUNDFOCUS": "#140020",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTBORDER": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTBORDERFOCUS": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_INPUTTEXT": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CARDBACKGROUND": "#1a0028",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CARDBACKGROUNDHOVER": "#240038",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CARDBORDER": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_CARDSHADOWBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SCROLLBARTRACKBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SCROLLBARTHUMBBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SCROLLBARTHUMBHOVERBASE": "#00ffff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_ACCENTPRIMARY": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_ACCENTSECONDARY": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_DIVIDERCOLORBASE": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SIDEBARBACKGROUND": "#050008",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SIDEBARBORDER": "#ff00ff",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_SUCCESSCOLOR": "#00ff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_WARNINGCOLOR": "#ffff00",
  "COLOR_TIMELINE_SKINS_PSYCHEDELIC_DANGERCOLOR": "#ff0000",
  "COLOR_TIMELINE_CLIPS_VIDEO_OUTER": "#e30f63",
  "COLOR_TIMELINE_CLIPS_VIDEO_OUTERSELECTED": "#ff6b9d",
  "COLOR_TIMELINE_CLIPS_VIDEO_INNERBASE": "#e30f63",
  "COLOR_TIMELINE_CLIPS_VIDEO_GLOWCOLORBASE": "#e30f63",
  "COLOR_TIMELINE_CLIPS_VIDEO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_CLIPS_IMAGE_OUTER": "#a654b2",
  "COLOR_TIMELINE_CLIPS_IMAGE_OUTERSELECTED": "#b96bc5",
  "COLOR_TIMELINE_CLIPS_IMAGE_INNERBASE": "#a654b2",
  "COLOR_TIMELINE_CLIPS_IMAGE_GLOWCOLORBASE": "#a654b2",
  "COLOR_TIMELINE_CLIPS_IMAGE_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_CLIPS_AUDIO_OUTER": "#2978c4",
  "COLOR_TIMELINE_CLIPS_AUDIO_OUTERSELECTED": "#6aa8e3",
  "COLOR_TIMELINE_CLIPS_AUDIO_INNERBASE": "#2978c4",
  "COLOR_TIMELINE_CLIPS_AUDIO_GLOWCOLORBASE": "#2978c4",
  "COLOR_TIMELINE_CLIPS_AUDIO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_CLIPS_OVERLAY_OUTER": "#f3b346",
  "COLOR_TIMELINE_CLIPS_OVERLAY_OUTERSELECTED": "#f5c56b",
  "COLOR_TIMELINE_CLIPS_OVERLAY_INNERBASE": "#f3b346",
  "COLOR_TIMELINE_CLIPS_OVERLAY_GLOWCOLORBASE": "#f3b346",
  "COLOR_TIMELINE_CLIPS_OVERLAY_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_CLIPS_PLACEHOLDER_OUTER": "#7f7f7f",
  "COLOR_TIMELINE_CLIPS_PLACEHOLDER_OUTERSELECTED": "#bfbfbf",
  "COLOR_TIMELINE_CLIPS_PLACEHOLDER_INNERBASE": "#b4bebe",
  "COLOR_TIMELINE_CLIPS_PLACEHOLDER_GLOWCOLORBASE": "#7f7f7f",
  "COLOR_TIMELINE_CLIPS_PLACEHOLDER_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYTYPES_VIDEO": "#e30f63",
  "COLOR_TIMELINE_LEGACYTYPES_AUDIO": "#7187c7",
  "COLOR_TIMELINE_LEGACYTYPES_IMAGE": "#9579b5",
  "COLOR_TIMELINE_LEGACYTYPES_OVERLAY": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYTYPES_PLACEHOLDER": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_BACKGROUNDCOLOR": "#e30f63",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_GRADIENTTOP": "#ff6b92",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_GRADIENTBOTTOM": "#dc5d90",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_SHADOWCOLORBASE": "#e30f63",
  "COLOR_TIMELINE_LEGACYCLIPS_VIDEO_SELECTEDBORDERCOLOR": "#dc5d90",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_BACKGROUNDCOLOR": "#7187c7",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_GRADIENTTOP": "#8197d7",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_GRADIENTBOTTOM": "#2978c4",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_SHADOWCOLORBASE": "#7187c7",
  "COLOR_TIMELINE_LEGACYCLIPS_AUDIO_SELECTEDBORDERCOLOR": "#2978c4",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_BACKGROUNDCOLOR": "#9579b5",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_GRADIENTTOP": "#a589c5",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_GRADIENTBOTTOM": "#b86ba2",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_SHADOWCOLORBASE": "#9579b5",
  "COLOR_TIMELINE_LEGACYCLIPS_IMAGE_SELECTEDBORDERCOLOR": "#b86ba2",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_BACKGROUNDCOLOR": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_GRADIENTTOP": "#9f9f9f",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_GRADIENTBOTTOM": "#bfbfbf",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_SHADOWCOLORBASE": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYCLIPS_OVERLAY_SELECTEDBORDERCOLOR": "#bfbfbf",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_BACKGROUNDCOLOR": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_GRADIENTTOP": "#9f9f9f",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_GRADIENTBOTTOM": "#bfbfbf",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_BORDERCOLORBASE": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_TEXTCOLOR": "#ffffff",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_SHADOWCOLORBASE": "#7f7f7f",
  "COLOR_TIMELINE_LEGACYCLIPS_PLACEHOLDER_SELECTEDBORDERCOLOR": "#bfbfbf",
  "COLOR_TIMELINE_INTERACTION_INVALIDDROPBASE": "#ff0000",
  "COLOR_TIMELINE_INTERACTION_MARQUEEFILLBASE": "#4299e1",
  "COLOR_TIMELINE_INTERACTION_MARQUEESTROKEBASE": "#4299e1",
  "COLOR_TIMELINE_RENDER_ACCENT": "#e30f63",
  "COLOR_TIMELINE_RENDER_SECONDARY": "#2978c4",
  "COLOR_TIMELINE_RENDER_FOREGROUND": "#ffffff",
  "COLOR_TIMELINE_RENDER_TEXTDARK": "#333333",
  "COLOR_TIMELINE_RENDER_TEXTPRIMARY": "#e0e0e0",
  "COLOR_TIMELINE_RENDER_TEXTMUTED": "#b8b8b8",
  "COLOR_TIMELINE_RENDER_TICKMAJOR": "#888888",
  "COLOR_TIMELINE_RENDER_TICKMINOR": "#666666",
  "COLOR_TIMELINE_RENDER_TICKFRAME": "#555555",
  "COLOR_TIMELINE_RENDER_TICKLABEL": "#aaaaaa",
  "COLOR_TIMELINE_RENDER_TICKBRIGHT": "#cccccc",
  "COLOR_TIMELINE_RENDER_RULERTOP": "#3a3a3a",
  "COLOR_TIMELINE_RENDER_RULERBOTTOM": "#2a2a2a",
  "COLOR_TIMELINE_RENDER_RULERBACKGROUND": "#1e1e1e",
  "COLOR_TIMELINE_RENDER_TRACKBACKGROUND": "#252525",
  "COLOR_TIMELINE_RENDER_TRACKVISUALEVEN": "#262020",
  "COLOR_TIMELINE_RENDER_TRACKNEUTRAL": "#181818",
  "COLOR_TIMELINE_RENDER_TRACKAUDIOODD": "#212225",
  "COLOR_TIMELINE_RENDER_DROPBORDER": "#777777",
  "COLOR_TIMELINE_RENDER_INVALIDDROPFILL": "#dd0000",
  "COLOR_TIMELINE_RENDER_INVALIDDROPBORDER": "#ff4444",
  "COLOR_TIMELINE_RENDER_DURATIONMARKER": "#e74c3c",
  "COLOR_TIMELINE_RENDER_PROCESSING": "#fb923c",
  "COLOR_TIMELINE_RENDER_DRAGSELECTION": "#4299e1",
  "COLOR_TIMELINE_RENDER_OVERLAY": "#000000",
  "COLOR_TIMELINE_UI_SURFACE_HEADER": "#1e1e1e",
  "COLOR_TIMELINE_UI_SURFACE_CONTROL": "#2a2a2a",
  "COLOR_TIMELINE_UI_SURFACE_HOVER": "#4a4a4a",
  "COLOR_TIMELINE_UI_SURFACE_PREVIEW": "#0d0d0d",
  "COLOR_TIMELINE_UI_TEXT_SECONDARY": "#b8b8b8",
  "COLOR_TIMELINE_UI_SLIDER_THUMB": "#cccccc",
  "COLOR_TIMELINE_UI_SAVE_TEXTHOVER": "#93c5fd",
  "COLOR_TIMELINE_UI_EXPORT_TEXTHOVER": "#ff8fb3",
  "COLOR_TIMELINE_UI_EXPORT_ACTIVE": "#c70d56",
  "COLOR_TIMELINE_UI_DELETE_TEXTHOVER": "#ff6b6b",
  "COLOR_TIMELINE_UI_DELETE_ARMED": "#dc2626",
  "COLOR_TIMELINE_UI_DELETE_ARMEDHOVER": "#b91c1c",
  "COLOR_TIMELINE_UI_DELETE_CONFIRMHOVER": "#d4485f",
  "COLOR_TIMELINE_UI_DROP_VISUALBORDER": "#fe4f7e",
  "COLOR_TIMELINE_UI_DROP_VISUAL": "#3a2a30",
  "COLOR_TIMELINE_UI_DROP_VISUALPULSE": "#4a2a38",
  "COLOR_TIMELINE_UI_DROP_AUDIO": "#2a3038",
  "COLOR_TIMELINE_UI_DROP_AUDIOPULSE": "#2a3848",
  "COLOR_TIMELINE_UI_SELECTION_MARQUEE": "#4299e1",
  "COLOR_TIMELINE_UI_PLAY_HOVER": "#ff5287",
  "COLOR_TIMELINE_UI_ADDTRACK_BACKGROUND": "#4a9eff",
  "COLOR_TIMELINE_UI_ADDTRACK_HOVER": "#3a8eef",
  "COLOR_TIMELINE_UI_TRACK_SELECTED": "#242026",
  "COLOR_TIMELINE_UI_SOLO_TEXT": "#c9a227",
  "COLOR_TIMELINE_UI_SOLO_BACKGROUND": "#b48c32",
  "COLOR_TIMELINE_UI_WARNING_TEXT": "#d97706",
  "COLOR_TIMELINE_UI_WORKFLOW_HOVER": "#ff6b94",
  "COLOR_TIMELINE_UI_IMAGE_HOVER": "#6ed69d",
  "COLOR_TIMELINE_UI_LIVE_TEXT": "#4ade80",
  "COLOR_TIMELINE_UI_VISIBILITY_BACKGROUND": "#2a4a2a",
  "COLOR_TIMELINE_UI_VISIBILITY_TEXT": "#66cc66",
  "COLOR_TIMELINE_UI_VISIBILITY_BORDER": "#4a6a4a",
  "COLOR_TIMELINE_UI_VISIBILITY_HOVER": "#3a5a3a",
  "COLOR_TIMELINE_UI_CONFIRM_BACKGROUND": "#ff4444",
  "COLOR_TIMELINE_UI_CONFIRM_HOVER": "#ff5555",
  "COLOR_TIMELINE_UI_CONFIRM_ACTIVE": "#cc3333",
  "COLOR_TIMELINE_UI_GENERATING_TEXT": "#ffc107",
  "COLOR_TIMELINE_UI_STATUS_SUCCESS": "#4caf50",
  "COLOR_TIMELINE_UI_STATUS_ERROR": "#f44336",
  "COLOR_TIMELINE_UI_ASSET_UNKNOWN": "#6b7280",
  "COLOR_EDITOR_SURFACE_DEEP": "#111111",
  "COLOR_EDITOR_SURFACE_CANVAS": "#161616",
  "COLOR_EDITOR_SURFACE_PANEL": "#1e1e1e",
  "COLOR_EDITOR_SURFACE_STRIPE": "#222222",
  "COLOR_EDITOR_SURFACE_CONTROL": "#2a2a2a",
  "COLOR_EDITOR_TEXT_SECONDARY": "#b8b8b8",
  "COLOR_EDITOR_TEXT_MUTED": "#6b7280",
  "COLOR_EDITOR_TEXT_SUBTLE": "#9ca3af",
  "COLOR_EDITOR_TEXT_HINT": "#a0aec0",
  "COLOR_EDITOR_GRAPH_CONNECTION": "#61dafb",
  "COLOR_EDITOR_GRAPH_TEXT": "#d99a3a",
  "COLOR_EDITOR_GRAPH_CUSTOM": "#a855f7",
  "COLOR_EDITOR_GRAPH_SELECTION": "#e91e63",
  "COLOR_EDITOR_STATUS_APPROVED": "#22c55e",
  "COLOR_EDITOR_STATUS_SUCCESSTEXT": "#4ade80",
  "COLOR_EDITOR_STATUS_ERRORBRIGHT": "#ff4444",
  "COLOR_EDITOR_STATUS_BLOCKEDTEXT": "#fca5a5",
  "COLOR_EDITOR_STATUS_PARAMETERWARNING": "#fb923c",
  "COLOR_EDITOR_ACTION_EDITHOVER": "#ff8fb3",
  "COLOR_EDITOR_ACTION_SHOTHOVER": "#f01f73",
  "COLOR_EDITOR_ACTION_DELETEHOVER": "#d4485f",
  "COLOR_EDITOR_TOAST_BORDER": "#e5e7eb",
  "COLOR_EDITOR_TOAST_SURFACE": "#f9fafb",
  "COLOR_EDITOR_TOAST_TEXT": "#1f2937",
  "COLOR_EDITOR_TOAST_TEXTSECONDARY": "#374151",
  "COLOR_EDITOR_TOAST_MUTED": "#94a3b8",
  "COLOR_EDITOR_TOAST_SUCCESS": "#10b981",
  "COLOR_EDITOR_TOAST_REMOVED": "#fee2e2",
  "COLOR_EDITOR_TOAST_ADDED": "#dcfce7",
  "COLOR_EDITOR_PLACEHOLDER_BORDER": "#e2e8f0",
  "COLOR_EDITOR_PLACEHOLDER_PURPLE": "#c084fc",
  "COLOR_EDITOR_PALETTE_AMBER_50": "oklch(98.7% 0.022 95.277)",
  "COLOR_EDITOR_PALETTE_AMBER_100": "oklch(96.2% 0.059 95.617)",
  "COLOR_EDITOR_PALETTE_AMBER_200": "oklch(92.4% 0.12 95.746)",
  "COLOR_EDITOR_PALETTE_AMBER_300": "oklch(87.9% 0.169 91.605)",
  "COLOR_EDITOR_PALETTE_AMBER_400": "oklch(82.8% 0.189 84.429)",
  "COLOR_EDITOR_PALETTE_AMBER_500": "oklch(76.9% 0.188 70.08)",
  "COLOR_EDITOR_PALETTE_AMBER_600": "oklch(66.6% 0.179 58.318)",
  "COLOR_EDITOR_PALETTE_AMBER_700": "oklch(55.5% 0.163 48.998)",
  "COLOR_EDITOR_PALETTE_AMBER_800": "oklch(47.3% 0.137 46.201)",
  "COLOR_EDITOR_PALETTE_AMBER_900": "oklch(41.4% 0.112 45.904)",
  "COLOR_EDITOR_PALETTE_AMBER_950": "oklch(27.9% 0.077 45.635)",
  "COLOR_EDITOR_PALETTE_BLUE_50": "#f0f7ff",
  "COLOR_EDITOR_PALETTE_BLUE_100": "#e0effe",
  "COLOR_EDITOR_PALETTE_BLUE_200": "#bae0fd",
  "COLOR_EDITOR_PALETTE_BLUE_300": "#7cc8fb",
  "COLOR_EDITOR_PALETTE_BLUE_400": "#38a9f5",
  "COLOR_EDITOR_PALETTE_BLUE_500": "#2978c4",
  "COLOR_EDITOR_PALETTE_BLUE_600": "#1d5fa3",
  "COLOR_EDITOR_PALETTE_BLUE_800": "#1a416e",
  "COLOR_EDITOR_PALETTE_BLUE_900": "#1b375c",
  "COLOR_EDITOR_PALETTE_BLUE_950": "#12233d",
  "COLOR_EDITOR_PALETTE_EMERALD_500": "oklch(69.6% 0.17 162.48)",
  "COLOR_EDITOR_PALETTE_GRAY_50": "oklch(98.5% 0.002 247.839)",
  "COLOR_EDITOR_PALETTE_GRAY_100": "oklch(96.7% 0.003 264.542)",
  "COLOR_EDITOR_PALETTE_GRAY_200": "oklch(92.8% 0.006 264.531)",
  "COLOR_EDITOR_PALETTE_GRAY_300": "oklch(87.2% 0.01 258.338)",
  "COLOR_EDITOR_PALETTE_GRAY_400": "oklch(70.7% 0.022 261.325)",
  "COLOR_EDITOR_PALETTE_GRAY_500": "oklch(55.1% 0.027 264.364)",
  "COLOR_EDITOR_PALETTE_GRAY_600": "oklch(44.6% 0.03 256.802)",
  "COLOR_EDITOR_PALETTE_GRAY_700": "oklch(37.3% 0.034 259.733)",
  "COLOR_EDITOR_PALETTE_GRAY_800": "oklch(27.8% 0.033 256.848)",
  "COLOR_EDITOR_PALETTE_GRAY_900": "oklch(21% 0.034 264.665)",
  "COLOR_EDITOR_PALETTE_GRAY_950": "oklch(13% 0.028 261.692)",
  "COLOR_EDITOR_PALETTE_GREEN_50": "oklch(98.2% 0.018 155.826)",
  "COLOR_EDITOR_PALETTE_GREEN_100": "oklch(96.2% 0.044 156.743)",
  "COLOR_EDITOR_PALETTE_GREEN_200": "oklch(92.5% 0.084 155.995)",
  "COLOR_EDITOR_PALETTE_GREEN_300": "oklch(87.1% 0.15 154.449)",
  "COLOR_EDITOR_PALETTE_GREEN_400": "oklch(79.2% 0.209 151.711)",
  "COLOR_EDITOR_PALETTE_GREEN_500": "oklch(72.3% 0.219 149.579)",
  "COLOR_EDITOR_PALETTE_GREEN_600": "oklch(62.7% 0.194 149.214)",
  "COLOR_EDITOR_PALETTE_GREEN_800": "oklch(44.8% 0.119 151.328)",
  "COLOR_EDITOR_PALETTE_GREEN_900": "oklch(39.3% 0.095 152.535)",
  "COLOR_EDITOR_PALETTE_GREEN_950": "oklch(26.6% 0.065 152.934)",
  "COLOR_EDITOR_PALETTE_PURPLE_100": "oklch(94.6% 0.033 307.174)",
  "COLOR_EDITOR_PALETTE_PURPLE_400": "oklch(71.4% 0.203 305.504)",
  "COLOR_EDITOR_PALETTE_PURPLE_600": "oklch(55.8% 0.288 302.321)",
  "COLOR_EDITOR_PALETTE_PURPLE_900": "oklch(38.1% 0.176 304.987)",
  "COLOR_EDITOR_PALETTE_RED_50": "oklch(97.1% 0.013 17.38)",
  "COLOR_EDITOR_PALETTE_RED_100": "oklch(93.6% 0.032 17.717)",
  "COLOR_EDITOR_PALETTE_RED_200": "oklch(88.5% 0.062 18.334)",
  "COLOR_EDITOR_PALETTE_RED_300": "oklch(80.8% 0.114 19.571)",
  "COLOR_EDITOR_PALETTE_RED_400": "oklch(70.4% 0.191 22.216)",
  "COLOR_EDITOR_PALETTE_RED_500": "oklch(63.7% 0.237 25.331)",
  "COLOR_EDITOR_PALETTE_RED_600": "oklch(57.7% 0.245 27.325)",
  "COLOR_EDITOR_PALETTE_RED_700": "oklch(50.5% 0.213 27.518)",
  "COLOR_EDITOR_PALETTE_RED_800": "oklch(44.4% 0.177 26.899)",
  "COLOR_EDITOR_PALETTE_RED_900": "oklch(39.6% 0.141 25.723)",
  "COLOR_EDITOR_PALETTE_RED_950": "oklch(25.8% 0.092 26.042)",
  "COLOR_EDITOR_PALETTE_YELLOW_50": "oklch(98.7% 0.026 102.212)",
  "COLOR_EDITOR_PALETTE_YELLOW_100": "oklch(97.3% 0.071 103.193)",
  "COLOR_EDITOR_PALETTE_YELLOW_200": "oklch(94.5% 0.129 101.54)",
  "COLOR_EDITOR_PALETTE_YELLOW_300": "oklch(90.5% 0.182 98.111)",
  "COLOR_EDITOR_PALETTE_YELLOW_400": "oklch(85.2% 0.199 91.936)",
  "COLOR_EDITOR_PALETTE_YELLOW_500": "oklch(79.5% 0.184 86.047)",
  "COLOR_EDITOR_PALETTE_YELLOW_600": "oklch(68.1% 0.162 75.834)",
  "COLOR_EDITOR_PALETTE_YELLOW_700": "oklch(55.4% 0.135 66.442)",
  "COLOR_EDITOR_PALETTE_YELLOW_800": "oklch(47.6% 0.114 61.907)",
  "COLOR_EDITOR_PALETTE_YELLOW_900": "oklch(42.1% 0.095 57.708)",
  "COLOR_EDITOR_PALETTE_YELLOW_950": "oklch(28.6% 0.066 53.813)",
  "SPACE_1": "4px",
  "SPACE_2": "calc(4px * 2)",
  "SPACE_3": "calc(4px * 3)",
  "SPACE_4": "calc(4px * 4)",
  "SPACE_6": "calc(4px * 6)",
  "SPACE_8": "calc(4px * 8)",
  "RADIUS_LEGACY_BASE": "1rem",
  "RADIUS_LEGACY_SM": "calc(1rem - 4px)",
  "RADIUS_LEGACY_MD": "calc(1rem - 2px)",
  "RADIUS_LEGACY_XL": "calc(1rem + 4px)",
  "RADIUS_MD": "8px",
  "RADIUS_SM": "4px",
  "RADIUS_DEFAULT": "8px",
  "RADIUS_LG": "12px",
  "RADIUS_CONTROL": "10px",
  "RADIUS_FULL": "9999px"
} as const;

export type TokenKey = keyof typeof tokens;
